import { render, staticRenderFns } from "./ArticleKitComponentsTableForm.vue?vue&type=template&id=5823cd02&"
import script from "./ArticleKitComponentsTableForm.vue?vue&type=script&lang=js&"
export * from "./ArticleKitComponentsTableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports